import { darken, lighten, alpha, getContrastRatio } from '@material-ui/core/styles'

// El color principal sale de cada cliente (background_color) y a veces llega en
// formatos que MUI no sabe descomponer ('secondary', nombres CSS...). En ese caso
// se devuelve el color tal cual en lugar de romper el render.
export const safeDarken = (color, coefficient = 0.15) => {
  try {
    return darken(color, coefficient)
  } catch (e) {
    return color
  }
}

export const safeAlpha = (color, value) => {
  try {
    return alpha(color, value)
  } catch (e) {
    return color
  }
}

// Texto legible sobre un fondo arbitrario (los colores de estado los define cada cliente)
export const readableTextOn = (background, light = '#FFFFFF', dark = '#171717') => {
  try {
    return getContrastRatio(background, light) >= 3 ? light : dark
  } catch (e) {
    return dark
  }
}

// Tinte opaco (mezcla con blanco); para fondos que no pueden transparentar, como una cabecera sticky
export const safeLighten = (color, coefficient = 0.9) => {
  try {
    return lighten(color, coefficient)
  } catch (e) {
    return color
  }
}
